import storeConfig from 'Stores/pqjmdlht5a-1754992/config';

try {
  storeConfig.InitFunc?.();
} catch (e) {
  console.error(e);
  import('Diagnostics/diagnostics')
    .then(({ logRuntimeError }) => logRuntimeError({ source: 'init_func', error: e }))
    .catch(() => {});
}
